import { render, staticRenderFns } from "./selecter.vue?vue&type=template&id=112f462a&scoped=true&"
import script from "./selecter.vue?vue&type=script&lang=js&"
export * from "./selecter.vue?vue&type=script&lang=js&"
import style0 from "./selecter.vue?vue&type=style&index=0&id=112f462a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f462a",
  null
  
)

export default component.exports